import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(theme => ({
  accordionDetailsInner: {
    width: '100%',
    backgroundColor: theme.colors.dark.darkSlateBlue,
  },
}));
